import { ListItem, ListItemText } from "@mui/material";

type QMScoreProps = {
	score: number;
};

export const QMScore = (props: QMScoreProps) => {
	const { score } = props;
	const successStyle = {
		borderColor: "#198025",
	};
	const failStyle = {
		borderColor: "#D92121",
	};
	const isSuccess = (score: number) => score > 4;
	const style = {
		borderWidth: "3px",
		borderStyle: "solid",
		borderRadius: "10px",
		...(isSuccess(score)
			? {
					...successStyle,
			  }
			: {
					...failStyle,
			  }),
		width: "8rem",
	};
	return (
		<ListItem sx={style}>
			<ListItemText primary="Score: " secondary={score.toFixed(2)} />
		</ListItem>
	);
};
